<template>
    <section class="a-overview">
        <div class="a-overview__wrapper">
            <div class="a-overview__wrap">
                <h2 class="a-overview__title">
                    {{ jsonOverviewData.name }}
                </h2>
                <p class="a-overview__desc">
                    {{ jsonOverviewData.preview_text }}
                </p>
            </div>
            <a
                class="a-overview__link"
                :class="{ 'a-arrow-icon': jsonOverviewData.link_to_report }"
                :href="jsonOverviewData.link_to_report ? jsonOverviewData.link_to_report : jsonOverviewData.file.src"
                :title="jsonOverviewData.link_to_report ? 'Читать отчет' : jsonOverviewData.file.title"
                :download="jsonOverviewData.link_to_report ? null : jsonOverviewData.file.original_name">
                <svg v-if="!jsonOverviewData.link_to_report" width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 0L5.5 9H10L5 15L0 9H4.5L4.5 0H5.5ZM10 18.5V17.5H0V18.5H10Z" fill="#8BC540"/>
                </svg>
                <span>{{ jsonOverviewData.link_to_report ? 'Читать отчет' : 'Скачать отчёт' }}</span>
            </a>
        </div>
        <div class="a-overview__img-wrapper">
            <picture-helper :image-data="overviewData.imageData"/>
        </div>
    </section>
</template>

<script>
    import PictureHelper from './helpers/PictureHelper'

    export default {
        name: 'Overview',
        components: {
            PictureHelper
        },
        props: {
            overviewData: Object,
            jsonOverviewData: Object
        },
    }
</script>